import {useEffect, useState} from 'react'

/**
 * A value that changes every minute, for memoised values that depend on the current time (e.g. table columns that
 * show 'too late' icons): add it to the dependencies so they're recomputed every minute.
 */
export default function useMinuteTick(): number {
    const [tick, setTick] = useState(() => Date.now())

    useEffect(() => {
        const interval = setInterval(() => setTick(Date.now()), 60 * 1000)

        return () => clearInterval(interval)
    }, [])

    return tick
}
